import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  createInvitationGroup,
  isCreateInvitationGroupPanelOpenSelector,
  setIsCreateInvitationGroupPanelOpen,
} from '../../../../../../../features/pageFeatures/invitationGroupAdministrationPageSlice';

export const useCreateInvitationGroup = () => {
  const dispatch = useDispatch();
  const [title, setTitle] = useState();

  const isPanelOpen = useSelector(isCreateInvitationGroupPanelOpenSelector);

  function onPanelClose() {
    dispatch(setIsCreateInvitationGroupPanelOpen(false));
    setTitle();
  }

  function onConfirm() {
    dispatch(createInvitationGroup({ title }));
    setTitle();
  }

  return {
    title,
    setTitle,
    isPanelOpen,
    onPanelClose,
    onConfirm,
  };
};
